import React from 'react';
import { Card, Table } from 'antd';
import type { TableProps } from 'antd';
import SPEnumKeyToText from 'components/product-price/base/EnumKeyToText';


interface PropsType {
	enums?: any;
	data?: any;
	changePriceFormat?: any;
}

interface TableDataType {
	id: number;
	username?: string;
	cell_encrypt?: string;
	user_status?: number;
	role_list?: any;
	store_list?: any;
	create_time?: string;
	update_time?: string;
	start_time?: any;
	end_time?: any;
}

const DiscountDetails: React.FC<PropsType> = props => {
  const { data, changePriceFormat,enums } = props;

	const columns: TableProps<TableDataType>['columns'] = [
		{
			title: '优惠所属',
			dataIndex: 'share',
			key: 'share',
		},
		{
			title: '活动ID',
			dataIndex: 'promotion_id',
			key: 'promotion_id',
		},
		// {
		// 	title: '活动类型',
		// 	dataIndex: 'promotion_type',
		// 	key: 'promotion_type',
		// 	render: (_, record) => <SPEnumKeyToText data={record} enums={enums} valueKey={'promotion_type'} nameSpace={'order_promotion'} />,
		// },
		{
			title: '活动标签',
			dataIndex: 'promotion_name',
			key: 'promotion_name',
		},
		{
			title: '优惠金额',
			dataIndex: 'promotion_amount',
			key: 'promotion_amount',
			render: text => changePriceFormat(text),
		},
	];

	return (
		<Card title="优惠明细" style={{ marginTop: '20px' }}>
			<Table columns={columns} dataSource={data?.promotion_items} rowKey={cols => cols.id} pagination={false} footer={() => <span>总计¥{changePriceFormat(data.total_amount)}</span>} />
		</Card>
	);
};

export default DiscountDetails;
